import { render } from "./MkSandwich.vue?vue&type=template&id=116fa51f&scoped=true"
import script from "./MkSandwich.vue?vue&type=script&lang=js"
export * from "./MkSandwich.vue?vue&type=script&lang=js"

import "./MkSandwich.vue?vue&type=style&index=0&id=116fa51f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-116fa51f"]])

export default __exports__